import axios from "axios";
import { useRef, useEffect, useState, useMemo } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import GreenButton from "../../../../ui/GreenButton";

import Swal from "sweetalert2";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";




const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const FormContainer = styled.form`
  width: 50%;
  background-color: #fff;
  display: flex; 
  align-items: flex-end;
  justify-content: center;
  gap: 5px;
  padding: 10px;

`;

const InputArea = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  width: 500px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 1px;
  height: 36px;
  border-radius: 5px;
  margin: 0px 10px;
`;

const Label = styled.label`
  color: #4f4f4f;
  font-weight: 600;
  font-size: 17px;

 
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; 
  padding-left: 1px;

  
`;

const Button = styled.button`
  padding: 0px 20px ;
  cursor: pointer;
  border-radius: 2px;
  border: none;
  background-color:  #fff;
  height: 42px;
  font-size: 16px;
  font-weight: bold;
  margin: 5px;
  color: #575757;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.1);

  }
`;


const TableWrapper = styled.div`
  overflow: auto;
  border-radius: 7px;
  background: #fff;
  max-width: 98%;   /* limite de largura */
  margin: auto;   /* centraliza */
  padding: 12px;/* leve respiro interno */
`;


export const Table = styled.table`
 
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;

  /* (opcionais do seu layout externo) */
  box-shadow: 0 0 2px #ccc;
  border-radius: 7px;
  margin-bottom: 10px;

  /* células padrão */
  th, td {
    padding: 12px 14px;
    font-size: 14px;
    color: #333;
  }

  /* cabeçalho fixo */
  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fafafa;
    color: #555;
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  /* listras + hover */
  tbody tr { transition: background 0.15s ease; }
  tbody tr:nth-child(even) { background: #fcfcfc; }
  tbody tr:hover { background: #E5F7EE; }

  /* divisórias e alinhamento */
  tbody td {
    border-bottom: 1px solid #f0f0f0;

  }
  tbody tr:last-child td { border-bottom: 0; }

  /* cantos arredondados */
  thead th:first-child { border-top-left-radius: 5px; }
  thead th:last-child  { border-top-right-radius: 5px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 5px; }
  tbody tr:last-child td:last-child  { border-bottom-right-radius: 5px; }

  /* descrição com quebra — sem mudar seu JSX (4ª coluna) */
  tbody td:nth-child(4) {
    max-width: 520px;
    white-space: pre-wrap;
    word-break: break-word;
  }

  @media (max-width: 780px) {
    min-width: 600px; /* força scroll horizontal no mobile */
    th, td { padding: 10px 12px; font-size: 13px; }
  }
`;


const ActionButton = styled.button`
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: transform .12s ease;
  &:hover { transform: scale(1.03); }
`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 25px; 
`;

export const Tr = styled.tr`
  text-align: center;

  @media (max-width: 640px) {
    align-items: center; 
    text-align: center;
  }
  @media (max-width: 420px) {
    align-items: center; 
    text-align: center;
  }
`;

export const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;

  
`;

export const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
 
`;

export const Td1 = styled.td`
  padding-top: 15px;
  text-align: center;

  
`;

export const Td2 = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
  
`;

export const Td3 = styled.td`
  width: 98%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 30px 0px 10px 0px;

  gap:10px;
  span{
    margin: 0px 5px;
  }

`;



const Select = styled.select`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Div2 = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;

const Div3 = styled.div`
  width: 98%;
  display: flex;
  align-items: center;
  justify-content:center;
  flex-direction: column;

`;

const Form = ({ urlApi, tipoChamado, subTipoChamado, itemSubTipoChamado, setAtualizaTipos }) => {

  //-------------------------------------------------------------------------------------------------//

  const ref = useRef();

  //-------------------------------------------------------------------------------------------------//

  const token = localStorage.getItem('token');

  //----------------------------------------ONEDIT RESPONSAVEL POR EDITAR O MODULO---------------------------------------------------------//

  const [onEdit, setOnEdit] = useState(null);
  useEffect(() => {
    const user = ref.current;

    if (onEdit) {
      user.desc_itemsubtipochamado.value = onEdit.DESC_ITEMSUBTIPOCHAMADO;
      setTipoChamadoSelecionado(onEdit.COD_TIPOCHAMADO);
      setSubTipoChamadoSelecionado(onEdit.COD_SUBTIPOCHAMADO);

      // Atualiza a lista de subtipos com base no tipo selecionado
      const filtrados = subTipoChamado.filter(
        (s) => String(s.COD_TIPOCHAMADO) === String(onEdit.COD_TIPOCHAMADO)
      );
      setSubTiposFiltrados(filtrados);
    } else {
      user.desc_itemsubtipochamado.value = "";
      setTipoChamadoSelecionado("");
      setSubTipoChamadoSelecionado("");
      setSubTiposFiltrados([]);
    }
  }, [onEdit, subTipoChamado]); // importante incluir subTipoChamado




  //onEdit para editar os modulo
  const handleEdit = (item) => {
    setOnEdit(item);
  };



  //----------------------------------------FUNÇÂO QUE SALVA POST/PUT---------------------------------------------------------//
  const [tipoChamadoSelecionado, setTipoChamadoSelecionado] = useState('');
  const [subTipoChamadoSelecionado, setSubTipoChamadoSelecionado] = useState('');
  const [subTiposFiltrados, setSubTiposFiltrados] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = ref.current;
    const desc_itemsubtipochamadoValue = user.desc_itemsubtipochamado.value.trim();


    if (!desc_itemsubtipochamadoValue || !tipoChamadoSelecionado || !subTipoChamadoSelecionado) {
      return toast.warn("Preencha todos os campos!");
    }


    const subTipoChamadoData = {
      cod_subtipochamado: subTipoChamadoSelecionado,
      cod_tipochamado: tipoChamadoSelecionado,
      desc_itemsubtipochamado: desc_itemsubtipochamadoValue,

    };

    const url = onEdit
      ? `${urlApi}central-ti/editar-item-subtipo-chamado/${onEdit.COD_ITEMSUBTIPOCHAMADO}`
      : `${urlApi}central-ti/adicionar-item-subtipo-chamado`;

    const method = onEdit ? "put" : "post";

    try {
      const response = await axios({
        method,
        url,
        data: subTipoChamadoData,
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(response.data);
      setAtualizaTipos(true);


      user.desc_itemsubtipochamado.value = "";
      setOnEdit(null);
    } catch (error) {
      let errorMessage = "Erro desconhecido";
      if (error.response) {
        errorMessage = error.response.data.error || errorMessage;

        toast.error("Erro ao adicionar: " + errorMessage);
      } else {
        console.error("Erro na solicitação:", error.message);
        toast.error("Erro na solicitação: " + error.message);
      }

    }
  };


  //----------------------------------------FUNÇÂO QUE DELETA O MODULO---------------------------------------------------------//

  //PopUp de confirmação para deletar
  const showPopUp = (detalhes) => {
    return new Promise((resolve) => {
      Swal.fire({
        title: `Essa ação é irreversível, tem certeza que gostaria de deletar esse tipo chamado: ${detalhes}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container',
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };



  // Deleta os usuários
  const handleDelete = async (item) => {
    const detalhes = `${item.DESC_ITEMSUBTIPOCHAMADO}`;
    const userConfirmed = await showPopUp(detalhes);

    if (!userConfirmed) return;

    try {
      const response = await axios.delete(`${urlApi}central-ti/deletar-item-subtipo-chamado/${item.COD_ITEMSUBTIPOCHAMADO}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(response.data.message || "Item subtipo deletado com sucesso.");
      setAtualizaTipos(true);
      setOnEdit(null);

    } catch (error) {
      console.error('Erro ao deletar o subtipo:', error);

      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        'Erro desconhecido ao deletar.';

      toast.error("Erro: " + errorMessage);
    }
  };






  //-------------------------------------------------------------------------------------------------//


  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(itemSubTipoChamado);
  const [tipoSelecionado, setTipoSelecionado] = useState('');


  //Input de pesquisa
  const handleSearch = async (term) => {
    try {
      const filtered = itemSubTipoChamado.filter((user) => {
        const itemsubtipo = (user.DESC_ITEMSUBTIPOCHAMADO || '').toString().toLowerCase();
        const subtipo = (user.DESC_SUBTIPOCHAMADO || '').toString().toLowerCase();
        const tipo = (user.DESC_TIPOCHAMADO || '').toLowerCase();


        const passaFiltroPesquisa =
          itemsubtipo.includes(term.toLowerCase()) ||
          tipo.includes(term.toLowerCase()) ||
          subtipo.includes(term.toLowerCase());

        const passaFiltroTipoPosse =
          tipoSelecionado === '' || user.COD_TIPOCHAMADO === parseInt(tipoSelecionado, 10);


        return passaFiltroPesquisa && passaFiltroTipoPosse;
      });

      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }

    setCurrentPage(1);
  };


  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, itemSubTipoChamado, tipoSelecionado]);

  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//
  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);

  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };






  const handleTipoChange = (e) => {
    const codSelecionado = e.target.value;
    setTipoChamadoSelecionado(codSelecionado);
    setSubTipoChamadoSelecionado(''); // limpa subtipo

    const filtrados = subTipoChamado.filter(
      (s) => String(s.COD_TIPOCHAMADO) === String(codSelecionado)
    );
    setSubTiposFiltrados(filtrados);
  };



  return (
    <Div>
      <FormContainer ref={ref} onSubmit={handleSubmit}>
        <InputArea>
          <Label>Crie um novo detalhamento:</Label>
          <Select

            value={tipoChamadoSelecionado}
            onChange={handleTipoChange}
            disabled={onEdit}
          >
            <option value="">Escolha uma opção</option>
            {tipoChamado.map((i) => (
              <option key={i.COD_TIPOCHAMADO} value={i.COD_TIPOCHAMADO}>
                {i.DESC_TIPOCHAMADO}
              </option>
            ))}
          </Select>
        </InputArea>
        <InputArea>
          <Select
            value={subTipoChamadoSelecionado}
            onChange={(e) => setSubTipoChamadoSelecionado(e.target.value)}
            disabled={onEdit} // continua desativado se estiver editando
          >
            <option value="">Escolha uma opção</option>
            {subTiposFiltrados.map((i) => (
              <option key={i.COD_SUBTIPOCHAMADO} value={i.COD_SUBTIPOCHAMADO}>
                {i.DESC_SUBTIPOCHAMADO}
              </option>
            ))}
          </Select>
        </InputArea>

        <InputArea>
          <Input name="desc_itemsubtipochamado" type="text" placeholder="Digite aqui..." />
        </InputArea>


        <ButtonContainer>
          <GreenButton title="Salvar" type="submit">
            Salvar
          </GreenButton>
        </ButtonContainer>
      </FormContainer>

      <Div3>
        <Td3 >

          <Input
            type="text"
            placeholder="Pesquisar..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Select
            value={tipoSelecionado}
            onChange={(e) => setTipoSelecionado(e.target.value)}
          >
            <option value="">Todas opção</option>
            {tipoChamado.map((tipo) => (
              <option key={tipo.COD_TIPOCHAMADO} value={tipo.COD_TIPOCHAMADO}>
                {tipo.DESC_TIPOCHAMADO}

              </option>
            ))}
          </Select>
          <Select value={itemsPerPage} onChange={(e) => {
            const value = e.target.value === "all" ? sortedData.length : parseInt(e.target.value);
            setItemsPerPage(value);
            setCurrentPage(1); // Resetar para a primeira página sempre que mudar
          }}>
            <option value={10}>10 por página</option>
            <option value={50}>50 por página</option>
            <option value={100}>100 por página</option>
            <option value="all">Todos</option>
          </Select>


          <Div2>
            <Button onClick={handlePrevPage} disabled={currentPage === 1}>
              <ImArrowLeft size={20} />
            </Button>
            <span><strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
            <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
              <ImArrowRight size={20} />
            </Button>
          </Div2>




        </Td3>



        {currentItems === 0 ? (
          <Tr>
            <Td colSpan={4} style={{ textAlign: 'center', padding: '20px', fontSize: '18px' }}>
              Nenhum detalhamento encontrado.
            </Td>
          </Tr>
        ) : (
          <>

            <TableWrapper>
              <Table>
                <thead>
                  <tr>
                    <th onClick={() => onColumnClick("DESC_ITEMSUBTIPOCHAMADO")} className={getSortClass("DESC_ITEMSUBTIPOCHAMADO")}>
                      Detalhamento do Problema: {getSortIcon("DESC_ITEMSUBTIPOCHAMADO")}
                    </th>
                    <th onClick={() => onColumnClick("DESC_SUBTIPOCHAMADO")} className={getSortClass("DESC_SUBTIPOCHAMADO")}>
                      Assunto {getSortIcon("DESC_SUBTIPOCHAMADO")}
                    </th>
                    <th onClick={() => onColumnClick("DESC_TIPOCHAMADO")} className={getSortClass("DESC_TIPOCHAMADO")}>
                      Tipo {getSortIcon("DESC_TIPOCHAMADO")}
                    </th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  {currentItems.map((item, i) => (
                    <tr key={i}>
                      <td width="auto">{item.DESC_ITEMSUBTIPOCHAMADO}</td>
                      <td>{item.DESC_SUBTIPOCHAMADO}</td>
                      <td>{item.DESC_TIPOCHAMADO}</td>


                      <td>
                        <ActionButton onClick={() => handleEdit(item)}>
                          Editar
                        </ActionButton>
                      </td>
                      <td>
                        <ActionButton onClick={() => handleDelete(item)}>
                          Deletar
                        </ActionButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </TableWrapper>
          </>
        )}
      </Div3>
      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </Div>

  );
};

export default Form;


